<div class="table-responsive rounded border" style="background: #ffffff; border-color: #e2e8f0 !important;" *ngIf="groupedData?.length; else noData">
  <table class="table table-hover table-bordered mb-0" style="font-size: 0.8125rem;">
    <thead style="background: var(--theme-primary, #123c53); color: #ffffff;">
      <tr>
        <th style="width:16.67%" class="py-2 text-uppercase font-weight-bold">Particulars</th>
        <th style="width:20.67%" class="py-2 text-uppercase font-weight-bold text-success">Positive Points</th>
        <th style="width:20.67%" class="py-2 text-uppercase font-weight-bold text-danger">Negative Points</th>
        <th style="width:12.67%" class="py-2 text-uppercase font-weight-bold">Created By</th>
        <th style="width:12.67%" class="py-2 text-uppercase font-weight-bold">Created On</th>
        <th style="width:16.65%" class="py-2 text-uppercase font-weight-bold">Final Remark</th>
      </tr>
    </thead>
    <tbody>
      <ng-container *ngFor="let group of groupedData">
        <tr *ngFor="let i of [].constructor(getMaxLen(group)); let ri = index">
          <td *ngIf="ri === 0" [attr.rowspan]="getMaxLen(group)" class="align-middle font-weight-bold text-dark" style="background: #fafbfc;">
            {{ group.PageName }}
          </td>
          <td>
            <span *ngIf="ri < group.positive.length" class="text-success font-weight-600">
              <i class="fas fa-check-circle mr-1"></i> {{ group.positive[ri] }}
            </span>
          </td>
          <td>
            <span *ngIf="ri < group.negative.length" class="text-danger font-weight-600">
              <i class="fas fa-times-circle mr-1"></i> {{ group.negative[ri] }}
            </span>
          </td>
          <td *ngIf="ri === 0" [attr.rowspan]="getMaxLen(group)" class="align-middle text-dark">
            {{ group.CreatedBy || '-' }}
          </td>
          <td *ngIf="ri === 0" [attr.rowspan]="getMaxLen(group)" class="align-middle text-dark">
            {{ group.CreatedOn || '-' }}
          </td>
          <td *ngIf="ri === 0" [attr.rowspan]="getMaxLen(group)" class="align-middle text-muted small">
            {{ group.FinalRemark || '-' }}
          </td>
        </tr>
      </ng-container>
    </tbody>
  </table>
</div>

<ng-template #noData>
  <div class="text-center p-3 bg-light rounded text-muted font-size-12 border">
    <i class="fas fa-info-circle mr-1"></i> No recommendation data available.
  </div>
</ng-template>
